﻿import { JsonServiceClient } from '@servicestack/client';
import { useCallback, useMemo, useState } from 'react';
import { client } from '../api/client';
import { DeleteRegistration, DeleteRegistrationResponse } from '../api/dtos';

const serviceStackClient: JsonServiceClient = client;

const url = '/conference/delete';

export const useDeleteRegistration = (id?: number) => {

    const [pending, setPending] = useState<boolean>(false);

    const deleteRegistration = useCallback(async (id?: number) => {

        if(id){
            setPending(true);
    
            const request = new DeleteRegistration();
            request.id = id;
            const response: DeleteRegistrationResponse = await serviceStackClient.delete(request);
        
            setPending(false);
    
            return response;
        }

    }, [id]);

    const deleteRegistrationService = useMemo(() => {
        return {
            deleteRegistration, 
            pending
        }
    }, [id, pending]);

    return deleteRegistrationService;
}

export default useDeleteRegistration;
